<template lang="pug">
  v-card.elevation-12
    v-toolbar(color="primary" dark flat)
      v-img.fill-height(src="@/assets/logo_emara3.png" alt="Emara play" position="left center" contain)
    v-card-text.px-10
      ValidationObserver(v-if="login_step == 1" v-slot="{ invalid, handleSubmit }")
        v-form(@submit.prevent="handleSubmit(submitLogin)")
          v-row
            v-col(cols="12")
              ValidationProvider(rules="required|email" v-slot="{ errors }")
                v-text-field(:label="username.label"
                  :name="username.name"
                  :prepend-icon="username.icon"
                  type="text"
                  v-model="userdata.email")
                span {{ errors[0] }}
              ValidationProvider(rules="required" v-slot="{ errors }")
                v-text-field(:label="password.label"
                  :name="password.name"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :prepend-icon="password.icon"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  v-model="userdata.password")
                span {{ errors[0] }}
            v-col(cols="12")
              v-spacer(text-right)
                v-btn.float-right(:disabled="invalid"
                  color="primary"
                  type="submit"
                  :loading="loadingLogin") {{ submitUserText }}
      ValidationObserver(v-else-if="login_step == 2" v-slot="{ invalid, handleSubmit }")
        p {{ infoPin }}
        v-form(@submit.prevent="handleSubmit(submitLogin)")
          v-row
            v-col(cols="12")
              ValidationProvider(rules="required" v-slot="{ errors }")
                v-text-field(:label="pin.label"
                  :name="pin.name"
                  :prepend-icon="pin.icon"
                  type="text"
                  v-model="pin_value")
                span {{ errors[0] }}
            v-col(cols="12")
              v-spacer(text-right)
                v-btn.float-right(:disabled="invalid"
                  color="primary"
                  type="submit"
                  :loading="loadingValidate") {{ submitPinText }}
</template>

<script>
  export default {
    name: 'LoginCard',
    props: {
      title: {
        type: String,
        default: 'Login Form'
      },
      username: {
        type: Object,
        default: function() {
          return {
            label: 'Username',
            name: 'username',
            icon: 'mdi-account'
          }
        }
      },
      password: {
        type: Object,
        default: function() {
          return {
            label: 'Password',
            name: 'password',
            icon: 'mdi-lock'
          }
        }
      },
      pin: {
        type: Object,
        default: function() {
          return {
            label: 'Pin',
            name: 'pin',
            icon: 'mdi-email-lock'
          }
        }
      },
      infoPin: {
        type: String,
        default: ''
      },
      submitUserText: {
        type: String,
        default: 'Sumbit'
      },
      submitPinText: {
        type: String,
        default: 'Login'
      },
    },
    data: () => ({
      userdata: {
        email: '',
        password: ''
      },
      pin_value: '',
      traducido: '',
      showPassword: false
    }),
    computed: {
      translations() {
        return this.$t("components.loginCard");
      },
      login_step() {
        return this.$store.state.login.step;
      },
      loadingLogin() {
        return this.$store.state.statusCode.userLogin.loading;
      },
      loadingValidate() {
        return this.$store.state.statusCode.userValidate.loading;
      },
    },
    methods: {
      submitLogin(){
        if(this.login_step == 1) {
          this.sendUserPass();
        } else if(this.login_step == 2) {
          this.sendPin();
        }
      },
      sendUserPass(){
        this.$store.dispatch('userLogin', this.userdata);
      },
      sendPin(){
        this.$store.dispatch('userValidate', this.pin_value);
      }
    }
  }
</script>

<style lang="sass">
</style>
